import { axiosClient } from '../api/httpClient';

export const updateWhiteLabelSettings = async (id, payload, originalValues = {}) => {
  const formData = new FormData();
  // Append all basic fields directly
  formData.append('loginPageTagLine', payload.loginPageTagLine || "");
  formData.append('loginPageYTTagLine', payload.homepageYTTagLine || "");
  formData.append('themeColor', payload.themeColor || "#ab322d");
  formData.append('secondaryColor', payload.secondaryColor || "#0693E3");
  formData.append('repurposingVideosCount', payload.repurposingVideosCount || 0);
  formData.append('websiteTypeId', payload.websiteTypeId || 3);
  formData.append('isActive', payload.isActive ?? 1);
  formData.append('subDomain', payload.subDomain || "");
  formData.append('portalSystemChanges', true); 
  // Image upload helper
  const addImage = async (key, currentVal, originalVal, filenamePrefix) => {
    if (currentVal && currentVal.startsWith("data:") && currentVal !== originalVal) {
      const blob = await fetch(currentVal).then(r => r.blob());
      formData.append(key, blob, `${filenamePrefix}-${Date.now()}`);
      if (originalVal) {
        formData.append(`previous${key.charAt(0).toUpperCase() + key.slice(1)}`, originalVal);
      }
    }
  };

  // Conditionally upload images
  await addImage("loginPageLogo", payload.loginPageLogo, originalValues.loginPageLogo, "login-page-logo");
  await addImage("sideBarLogo", payload.sideBarLogo, originalValues.sideBarLogo, "sidebar-logo");
  await addImage("favIcon", payload.favIcon, originalValues.favIcon, "favicon");
  await addImage("homepageYTLogo", payload.homepageYTLogo, originalValues.homepageYTLogo, "yt-helper-logo");
  await addImage("profileLogo", payload.profileLogo, originalValues.profileLogo, "profile-logo");

 try {
    const response = await axiosClient.post(`/api/white-label-customer/${id}`, formData);
    return response;
  } catch (error) {
    console.error("White label update failed:", error);
    throw error;
  }
};

export const deleteImageFromServer = async (imageUrl) => {
    try {
        const response = await axiosClient.post('/api/delete-image', { imageUrl });
        return { status: true, message: response.data.message };
    } catch (error) {
        return {
            status: false,
            message: error?.response?.data?.error || 'Failed to remove image'
        };
    }
};

export const updateCardHeaderColors = async (id, cardHeaderColors) => {
    try {
        const response = await axiosClient.post(`/api/white-label-customer/${id}/card-header-colors`, {
            card_header_colors: cardHeaderColors,
        });
        return { status: true, data: response.data, message: response.data?.message };
    } catch (error) {
        return {
            status: false,
            data: error?.response,
            message: error?.response?.data?.message || 'Failed to update card header colors'
        };
    }
};

/**
 * Save which sidebar links each role can see on a white label portal.
 * @param {number} id  website_type id of the white label customer
 * @param {object} sidebarLinksAccess  { [linkKey]: { all, admin, customer, qa, teamlead } }
 */
export const updateSidebarLinksAccess = async (id, sidebarLinksAccess) => {
  try {
    const response = await axiosClient.post(`/api/white-label-customer/${id}/sidebar-access`, {
      sidebar_links_access: sidebarLinksAccess,
    });
    return { status: true, data: response.data, message: response.data?.message };
  } catch (error) {
    return {
      status: false,
      data: error?.response,
      message: error?.response?.data?.message || 'Failed to update sidebar access'
    };
  }
};

/**
 * Save which questions are shown / required on each form of a white label portal.
 * @param {number} id  website_type id of the white label customer
 * @param {object} formQuestions  { [formKey]: { [questionKey]: { visible, required } } }
 */
export const updateFormQuestions = async (id, formQuestions) => {
  try {
    const response = await axiosClient.post(`/api/white-label-customer/${id}/form-questions`, {
      form_questions: formQuestions,
    });
    return { status: true, data: response.data, message: response.data?.message };
  } catch (error) {
    return {
      status: false,
      data: error?.response,
      message: error?.response?.data?.message || 'Failed to update form questions'
    };
  }
};

export const getWhiteLabelCustomerInfo = async () => {
  try {
    const response = await axiosClient.get('/api/white-label-customer-info/' + window.location.host);
    return { status: true, data: response.data };
  } catch (error) {
    return {
      status: false,
      data: error?.response,
      message: error?.response?.data?.error || 'Failed to fetch white-label info'
    };
  }
};
